module.exports = __webpack_public_path__ + "static/media/integration.e202dfee.png";